import * as Type from './actionsTypes';

const INITIAL_STATE = {
  selectedOlerite: {},
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case Type.OLERITE_FIND_ONE_SUCCESS:
    case Type.OLERITE_UPDATE_SUCCESS:
    case Type.OLERITE_CREATE_SUCCESS: {
      return { ...state, selectedOlerite: action.data };
    }
    case Type.OLERITE_CLEAR_SELECTED: {
      return { ...state, selectedOlerite: {} };
    }
    default:
      return state;
  }
}

export const getSelectedOlerite = state => state.rootState.olerite.selectedOlerite;
